import type { AggregateResult } from '../weldParameterAggregator'

export function validateAggregate(aggregate: AggregateResult | null | undefined): boolean {
  if (!aggregate || !Array.isArray(aggregate.rows)) return false
  if (aggregate.rows.length === 0) return false
  return aggregate.rows.every(
    (row) => typeof row.pass === 'string' && row.pass.trim().length > 0 && row.values
  )
}
